import React from "react";
import { styles } from "./styles";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Close } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";

interface Props {
  title: string;
  children: any;
  visible: boolean;
  onClose: Function;
}

const CustomModal = (props: Props) => {
  return (
    <Modal
      open={props.visible}
      aria-labelledby="add-category-modal-title"
      aria-describedby="add-category-modal-description"
    >
      <Box sx={styles.addCategory}>
        <Box sx={styles.headingBar}>
          <Typography sx={styles.heading_ac} variant="h3" component="h2">
            {props.title}
          </Typography>
          <IconButton onClick={() => props.onClose()} sx={styles.icon}>
            <Close />
          </IconButton>
        </Box>
        {props.children}
      </Box>
    </Modal>
  );
};

export default React.memo(CustomModal);
